import PropTypes from 'prop-types';
import { Modal } from 'antd';
import NewCustomButton from '../Common/NewCustomButton';
import { DeleteIcon, NewCloseIcon } from '../Common/Icons';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { ButtonTypes } from '../Common/CustomButton';

const CustomDialogBox = ({
  isModalOpen = false,
  onConfirm = () => {},
  onCancel = () => {},
  modalHeader = '',
  showDeleteDescrPath = false,
  className = '',
  userFullName = '',
  description = null,
  confirmLabel = '',
  cancelLabel = '',
  confirmIcon = undefined,
  hideCancel = false,
}) => {
  const trans = useSelector(translator);
  return (
    <div className="">
      <Modal
        title={modalHeader}
        centered
        open={isModalOpen}
        footer={null}
        closable={false}
        className="dialog-modal-conatiner"
      >
        <div className="dialogmodal">
          <div
            className={`${
              showDeleteDescrPath ? '' : 'dialogmodifydescription'
            } dialogmodaldescription`}
          >
            {description ? (
              description
            ) : (
              <>
                <p style={{ fontWeight: '400', whiteSpace: 'nowrap' }}>
                  {trans('AREYOUSUREYOUWANTTO')}{' '}
                  <span style={{ fontWeight: '700' }}>
                    {' '}
                    {trans('PERMANENTLYDELETE')} &quot;{userFullName}&quot;
                    {showDeleteDescrPath ? '' : '?'}
                  </span>
                </p>
                {showDeleteDescrPath && (
                  <p style={{ fontWeight: '400' }}>
                    {' '}
                    {trans('FROMETHE')}{' '}
                    <span style={{ fontWeight: '700' }}>{trans('STAFF?')}</span>{' '}
                  </p>
                )}
              </>
            )}
          </div>
          <div className={`dialogmodalbutton ${className}`}>
            {!hideCancel && (
              <NewCustomButton
                className="cancel"
                onClick={onCancel}
                label={cancelLabel || trans('CANCEL')}
                icon={<NewCloseIcon className="cancel-icon" />}
              />
            )}
            <NewCustomButton
              className="confirm"
              type={ButtonTypes.primary}
              label={confirmLabel || trans('DELETE')}
              icon={
                confirmIcon === undefined ? <DeleteIcon className="delete-icon" /> : confirmIcon
              }
              onClick={onConfirm}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

CustomDialogBox.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  modalHeader: PropTypes.node,
  showDeleteDescrPath: PropTypes.bool,
  className: PropTypes.string,
  userFullName: PropTypes.string,
  description: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmIcon: PropTypes.node,
  hideCancel: PropTypes.bool,
};

export default CustomDialogBox;
